import * as go from 'gojs';
import { angleBinding, locationBinding, lockedBindings, sizeBinding, zOrderBindings } from '../common/utils/bindings';
import { realPorts, virtualPorts } from './../common/parts/port';
import { IMAGE_NODE_IMAGE_PANEL } from './config/part-names';
import { imageSourceBinding } from './utils/bindings';

const $ = go.GraphObject.make;

const movable = true;
const resizable = true;
const rotatable = true;

export const imageNodeTemplate = () =>
  $(
    go.Node,
    go.Node.Spot,
    {
      resizeObjectName: IMAGE_NODE_IMAGE_PANEL,
      selectionObjectName: IMAGE_NODE_IMAGE_PANEL,
      locationObjectName: IMAGE_NODE_IMAGE_PANEL,
      isLayoutPositioned: false,
      toolTip: null,
      rotationSpot: go.Spot.Center,
      movable,
      resizable,
      rotatable,
    },
    picture(),
    locationBinding(),
    angleBinding(),
    ...lockedBindings({ movable, resizable, rotatable }),
    ...zOrderBindings(),
    ...virtualPorts(),
    ...realPorts(),
  );

const picture = () =>
  $(
    go.Picture,
    {
      name: IMAGE_NODE_IMAGE_PANEL,
    },
    imageSourceBinding(),
    sizeBinding(),
  );
